import {SystemStyleObject} from '@mui/system';

import {orangeColors} from '../../../../../../layouts/theme/designSystem';

type Styles = {
  borderStyleBottom: SystemStyleObject;
  borderStyleRight: SystemStyleObject;
  tableContainerStyles: SystemStyleObject;
  tableHeadStyles: SystemStyleObject;
  tableBodyStyles: SystemStyleObject;
};

export const getStyles = (): Styles => ({
  borderStyleBottom: {
    borderBottom: `1px solid ${orangeColors[3]}`,
  },
  borderStyleRight: {
    borderRight: `1px solid ${orangeColors[3]}`,
  },
  tableContainerStyles: {
    border: `1px solid ${orangeColors[5]}`,
    borderRadius: 4,
  },
  tableHeadStyles: {
    backgroundColor: orangeColors[3],
  },
  tableBodyStyles: {
    '& tr:nth-of-type(odd)': {
      backgroundColor: orangeColors[7],
    },
    '& tr:nth-of-type(even)': {
      backgroundColor: orangeColors[5],
    },
  },
});
